module.exports = require("pnp-webpack-plugin");